import * as React from 'react';
import * as Yup from 'yup';

import { Formik, FormikActions, FormikProps } from 'formik';
import { processApiError, toFormGroupStyle } from 'common/utils/form';

import { Activity } from 'common/api/models/Activity';
import { ActivityApi } from 'common/api/resources/ActivityApi';
import { FormErrorFeedback } from 'common/components/form/FormErrorFeedback';
import { FormGroup } from 'reactstrap';
import { Analytics } from 'common/utils/Analytics';

interface ActivityFeedNoteFormProps {
  entityId: string;
  entityType: string;
  onCancel: () => void;
  onSave: () => void;
}

interface ActivityFeedNoteFormState {
  subType: string;
}
interface NoteFormValues {
  note: string;
}

export class ActivityFeedNoteForm extends React.Component<ActivityFeedNoteFormProps, ActivityFeedNoteFormState> {
  validationSchema = Yup.object().shape({
    note: Yup.string().required('Required'),
  });

  state: ActivityFeedNoteFormState = {
    subType: 'NOTE',
  };

  handleSubmit = (values: NoteFormValues, actions: FormikActions<NoteFormValues>) => {
    ActivityApi.createActivity({
      entityId: this.props.entityId,
      entityType: this.props.entityType,
      type: this.props.entityType === 'CHAPTER' ? Activity.Type.CHAPTER_NOTE : Activity.Type.NOTE,
      subType: Activity.Type[this.state.subType],
      note: values.note,
    }).then(
      res => {
        this.props.onSave();
        Analytics.member.note();
        actions.setSubmitting(false);
        actions.resetForm();
      },
      err => {
        processApiError(err, actions);
      }
    );
  };

  handleChangeSubType = (e: React.ChangeEvent<HTMLSelectElement>) => {
    this.setState({ subType: e.currentTarget.value });
  };

  render() {
    return (
      <div className="card card-responsive">
        <div className="card-block">
          <Formik
            initialValues={{ note: '' }}
            validationSchema={this.validationSchema}
            onSubmit={this.handleSubmit}
            render={(form: FormikProps<NoteFormValues>) => (
              <form onSubmit={form.handleSubmit}>
                <FormGroup color={toFormGroupStyle('note', form)}>
                  <label>Note Type</label>
                  <select
                    name="note-subType"
                    className="form-control"
                    style={{ marginLeft: 10, width: 300, minWidth: 300, display: 'inline-block' }}
                    onChange={this.handleChangeSubType}
                    value={this.state.subType}
                  >
                    <option value="NOTE">Note</option>
                    <option value="DUES">Dues</option>
                    <option value="CREATE">Create</option>
                    <option value="UPDATE">Update</option>
                    <option value="MEMBER_APPLICATION">Member Application</option>
                    <option value="MEMBER_REINSTATE">Member Reinstated</option>
                    <option value="MEMBER_REREGISTER">Member Reregister</option>
                    <option value="MEMBER_TERMINATE">Member Terminate</option>
                    <option value="ORDER">Order</option>
                    <option value="MEETING">Meeting</option>
                    <option value="EMAIL">Email</option>
                    <option value="LETTER">Letter</option>
                    <option value="CALL">Call</option>
                    <option value="INFO">Info</option>
                    <option value="AWARD">Award</option>
                    <option value="REFUND">Refund</option>
                    <option value="COUPON">Coupon</option>
                    <option value="EXPIRE">Expire</option>
                    <option value="CUSTOM">Custom</option>
                    <option value="CHAPTER_POSITION_HISTORY">Chapter Position History</option>
                    <option value="LEARNING_PROGRAM_BADGE">Badge Learning Program</option>
                    <option value="INDIVIDUAL_LEARNING_PROGRAM_BADGE">Individual Badge Learning Program</option>
                    <option value="LEARNING_PROGRAM_CERTIFICATION">Certification Learning Program</option>
                  </select>
                  <textarea
                    name="note"
                    className="form-control"
                    placeholder="Add your note here. Notes are strictly internal to NKBA staff."
                    rows={3}
                    onChange={form.handleChange}
                    value={form.values.note}
                    autoFocus={true}
                  />
                  <FormErrorFeedback form={form} field="note" />
                </FormGroup>
                <div className="row">
                  <div className="col">
                    <button className="btn btn-sm btn-secondary" onClick={this.props.onCancel}>
                      Cancel
                    </button>{' '}
                    <button className="btn btn-sm btn-primary">Save</button>
                  </div>
                </div>
              </form>
            )}
          />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/activity/ActivityFeedNoteForm.tsx